import './styles/app.css';
import { App } from './app/App';
import { AsteroidGalleryApp } from './debug/AsteroidGalleryApp';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Application root not found.');

const showAsteroidGallery =
  import.meta.env.DEV && new URLSearchParams(window.location.search).get('debug') === 'asteroids';
const app = showAsteroidGallery ? new AsteroidGalleryApp(root) : new App(root);
app.start();

if (import.meta.hot) import.meta.hot.dispose(() => app.destroy());
